// src/notifications/handlers.ts
import { baseApi } from "@/redux/api/baseApi";
import { store } from "@/redux/store";
import { TNotification } from "@/types/types";
import { setQueryParam } from "@/utils/setQueryParam";

const openProjectRequestModalFromNotification = (data: Record<string, unknown>) => {
  let projectId = data?.project_id as string | undefined;

  if (!projectId) {
    const link =
      (data?.link as string | undefined) ||
      (data?.ProjectLink as string | undefined);
    if (link) {
      try {
        const u = new URL(link, window.location.origin);
        projectId = u.searchParams.get("project_id") ?? undefined;
      } catch {
        // ignore invalid URLs
      }
    }
  }

  if (!projectId) return;

  setQueryParam("project_id", projectId, { replace: false });
};

export function notificationHandlers(n: TNotification) {
  switch (n.template_id) {
    case "admin-planning-stage-completed-007": {
      const { orderId, videoId } = n.data as {
        orderId?: string;
        videoId?: string;
      };
      store.dispatch(
        baseApi.util.invalidateTags([
          "rawFootage",
          "videoSetup",
          ...(orderId
            ? [{ type: "CreatorProjectDetails" as const, id: orderId }]
            : []),
          ...(orderId && videoId
            ? [
                {
                  type: "OrderVideoStage" as const,
                  id: `${orderId}-${videoId}`,
                },
              ]
            : []),
        ]),
      );
      return;
    }

    case "creator-project-request-001":
    case "new_one_day_project": {
      openProjectRequestModalFromNotification(
        (n.data as Record<string, unknown>) ?? {},
      );
      return;
    }

    default:
      return;
  }
}
